import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule, FlexModule } from "@angular/flex-layout";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import { AuthorizedGuard } from "./guard/authorized.guard";
import { NoAuthGuard } from "./guard/no-auth.guard";
import { CommunicationMessageComponent } from "./service/Communication/components/communication-message/communication-message.component";

@NgModule({
    declarations: [CommunicationMessageComponent],
    imports: [CommonModule, MatIconModule, TranslateModule, FlexModule, FlexLayoutModule, MatButtonModule],
    providers: [NoAuthGuard, AuthorizedGuard]
})
export class CoreModule {}
